// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"2d77d3eb","532":"af93e972","787":"d43e6ab2"}[chunkId] + ".chunk.js";
};